module.exports = __webpack_public_path__ + "static/media/pdf.2bdcfefd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf.svg
// module id = 13
// module chunks = 0